import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "../../../box/src";
import { s__ } from "../../../i18n/src";
export const OrderSummaryEmpty = () => (_jsx(Box, { mb: 4, children: s__('ShoppingCard|Your cart is empty') }));
//# sourceMappingURL=OrderSummaryEmpty.js.map